export default __webpack_public_path__ + "static/media/pukanina2.a5c26a08.jpg";